<div *ngIf="segment" class="p-fluid">
    <div *ngIf="getControl('name') as control">
        <label>
            <span>Name</span>
            <input pInputText [formControl]="control" placeholder="Required">
        </label>
    </div>
    <div *ngIf="hasProperties()" class="p-grid p-jc-center">
        <ng-container [ngTemplateOutlet]="toggleTemplate" [ngTemplateOutletContext]="createTemplateContext('key')"></ng-container>
        <ng-container [ngTemplateOutlet]="toggleTemplate" [ngTemplateOutletContext]="createTemplateContext('required')"></ng-container>
        <ng-container [ngTemplateOutlet]="toggleTemplate" [ngTemplateOutletContext]="createTemplateContext('calculate')"></ng-container>
        <ng-container [ngTemplateOutlet]="toggleTemplate" [ngTemplateOutletContext]="createTemplateContext('variable')"></ng-container>
    </div>

    <div class="p-grid p-jc-center">
        <ng-container [ngSwitch]="segment.type.id">

            <ng-container *ngSwitchCase="SEGMENT_TYPES.LITERAL_TEXT">
                <div *ngIf="getControl('text') as control" class="p-col-12">
                    <textarea pInputTextarea rows="5" [formControl]="control"></textarea>
                </div>
            </ng-container>

            <ng-container *ngSwitchCase="SEGMENT_TYPES.TEXT_INPUT">
                <div *ngIf="getControl('width') as control" class="p-col-6">
                    <label>
                        <span>Width</span>
                        <input pInputText type="number" [formControl]="control">
                    </label>
                </div>
                <div *ngIf="getControl('height') as control" class="p-col-6">
                    <label>
                        <span>Height</span>
                        <input pInputText type="number" [formControl]="control">
                    </label>
                </div>
                <div *ngIf="getControl('textOption') as control" [ngClass]="'p-col-' + (templateType === TEMPLATE_TYPES.INSPECTION ? '6' : '12')">
                    <label>
                        <span>Text Style</span>
                        <p-dropdown appendTo="body" [options]="textStyleOptions" optionLabel="display" optionValue="value" [formControl]="control"></p-dropdown>
                    </label>
                </div>
                <div *ngIf="templateType === TEMPLATE_TYPES.INSPECTION && getControl('textAlignment') as control" class="p-col-6">
                    <label>
                        <span>Text Alignment</span>
                        <p-dropdown appendTo="body" [options]="textAlignmentOptions" optionLabel="display" optionValue="value" [formControl]="control"></p-dropdown>
                    </label>
                </div>
                <ng-container [ngTemplateOutlet]="toggleTemplate"
                              [ngTemplateOutletContext]="createTemplateContext('barcode', { label: 'Barcode or QR-Code'})">
                </ng-container>
            </ng-container>

            <ng-container *ngSwitchCase="SEGMENT_TYPES.NUMERIC_INPUT">
                <div *ngIf="getControl('units') as control" class="p-col-12">
                    <label>
                        <span>Units</span>
                        <input pInputText type="text" [formControl]="control" placeholder="None">
                    </label>
                </div>
                <div *ngIf="getControl('minValue') as control" class="p-col-6">
                    <label>
                        <span>Min Value</span>
                        <input pInputText type="number" [formControl]="control" placeholder="None">
                    </label>
                </div>
                <div *ngIf="getControl('maxValue') as control" class="p-col-6">
                    <label>
                        <span>Max Value</span>
                        <input pInputText type="number" [formControl]="control" placeholder="None">
                    </label>
                </div>
                <div *ngIf="getControl('belowMinAlertMessage') as control" class="p-col-6">
                    <label>
                        <span>Message below Min Value</span>
                        <textarea pInputTextarea rows="5" [formControl]="control" placeholder="None"></textarea>
                    </label>
                </div>
                <div *ngIf="getControl('aboveMaxAlertMessage') as control" class="p-col-6">
                    <label>
                        <span>Message above Max Value</span>
                        <textarea pInputTextarea rows="5" [formControl]="control" placeholder="None"></textarea>
                    </label>
                </div>
            </ng-container>

            <ng-container *ngSwitchCase="SEGMENT_TYPES.FILE_ATTACHMENT">
                <div *ngIf="getControl('minRequired') as control" class="p-col-6">
                    <label>
                        <span>Min Required</span>
                        <input pInputText type="number" [formControl]="control" placeholder="None">
                    </label>
                </div>
                <div *ngIf="getControl('maxAllowed') as control" class="p-col-6">
                    <label>
                        <span>Max Allowed</span>
                        <input pInputText type="number" [formControl]="control" placeholder="None">
                    </label>
                </div>
            </ng-container>

            <ng-container *ngSwitchCase="SEGMENT_TYPES.DATE_TIME">
                <ng-container [ngTemplateOutlet]="toggleTemplate" [ngTemplateOutletContext]="createTemplateContext('includeDate', { label: 'Include Date' })"></ng-container>
                <ng-container [ngTemplateOutlet]="toggleTemplate" [ngTemplateOutletContext]="createTemplateContext('includeTime', { label: 'Include Time' })"></ng-container>
            </ng-container>

            <ng-container *ngSwitchCase="SEGMENT_TYPES.TAG">
                <div *ngIf="getControl('tagValue') as control" class="p-col-12">
                    <tag-selector [logId]="logId" [singleValue]="true" [maxItems]="1" [formControl]="control"></tag-selector>
                </div>
            </ng-container>

            <ng-container *ngSwitchCase="SEGMENT_TYPES.TAG_CHOICE">
                <div *ngIf="getControl('tagValue') as control" class="p-col-12">
                    <label>
                        <span>Tag Parent</span>
                        <tag-selector [logId]="logId" [formControl]="control" [singleValue]="true" [maxItems]="1" placeholder="None"></tag-selector>
                    </label>
                </div>
                <div *ngIf="getControl('depth') as control" class="p-col-4">
                    <label>
                        <span>Descendant Depth Limit</span>
                        <input pInputText type="number" [formControl]="control" placeholder="None">
                    </label>
                </div>
                <div *ngIf="getControl('minRequired') as control" class="p-col-4">
                    <label>
                        <span>Min Required</span>
                        <input pInputText type="number" [formControl]="control" placeholder="None">
                    </label>
                </div>
                <div *ngIf="getControl('maxAllowed') as control" class="p-col-4">
                    <label>
                        <span>Max Allowed</span>
                        <input pInputText type="number" [formControl]="control" placeholder="None">
                    </label>
                </div>
            </ng-container>

            <ng-container *ngSwitchCase="SEGMENT_TYPES.SIGNATURE">
                <div *ngIf="getControl('text') as control" class="p-col-12">
                    <label>
                        <span>Text</span>
                        <textarea pInputTextarea [formControl]="control" placeholder="Required"></textarea>
                    </label>
                </div>
                <div class="p-col-12">
                    <ng-container [ngTemplateOutlet]="signatureUserTableTemplate"></ng-container>
                </div>
            </ng-container>

            <ng-container *ngSwitchCase="SEGMENT_TYPES.TEXT_CHOICE">
                <div *ngIf="getControl('choiceList') as control" class="p-col-12">
                    <label>
                        <span>Choice List</span>
                        <choicelist-selector [logId]="logId" [formControl]="control" [maxItems]="1" [singleValue]="true"
                                             (ngModelChange)="setControlState('defaultChoice', !!getSelectedList()); setControlValue('defaultChoice', null)"></choicelist-selector>
                    </label>
                </div>
                <div *ngIf="getControl('defaultChoice') as control" class="p-col-12">
                    <ng-container *ngVar="getSelectedList() as list">
                        <label>
                            <span>Default Choice</span>
                            <choicelist-item-selector [listId]="list?.id" [formControl]="control" placeholder="No Default" [maxItems]="1" [singleValue]="true"></choicelist-item-selector>
                        </label>
                    </ng-container>
                </div>
            </ng-container>

            <ng-container *ngSwitchCase="SEGMENT_TYPES.SIGNOFF">
                <div *ngIf="getControl('level') as control" class="p-col-12">
                    <label>
                        <span>Level</span>
                        <p-dropdown appendTo="body" placeholder="None" [showClear]="true" [options]="levelOptions" optionLabel="display" optionValue="value" [formControl]="control"></p-dropdown>
                    </label>
                </div>
                <ng-container *ngTemplateOutlet="toggleTemplate; context: createTemplateContext('allowReject', { label: 'Allow Reject' })"></ng-container>
                <ng-container *ngTemplateOutlet="toggleTemplate; context: createTemplateContext('allowUndo', { label: 'Allow Undo' })"></ng-container>
                <ng-container *ngTemplateOutlet="toggleTemplate; context: createTemplateContext('sendPendingSignoffNotification', { label: 'Notification on Pending' })"></ng-container>
                <ng-container *ngTemplateOutlet="toggleTemplate; context: createTemplateContext('requireOnShift', { label: 'Require on Shift' })"></ng-container>

                <div *ngIf="getControl('text') as control" class="p-col-12 p-md-6">
                    <label>
                        <span>Signoff Statement</span>
                        <textarea pInputTextarea placeholder="Signoff attestation" [formControl]="control"></textarea>
                    </label>
                </div>
                <div *ngIf="getControl('altText') as control" class="p-col-12 p-md-6">
                    <label>
                        <span>Reject Statement</span>
                        <textarea pInputTextarea placeholder="Signoff refutation" [formControl]="control"></textarea>
                    </label>
                </div>
                <div class="p-col-12 p-d-flex p-flex-column">
                    <label>
                      <span>Initial Signoff Users</span>
                    </label>
                    <ng-container *ngIf="getControl('allowAnyUser') as allowAnyUserControl">
                      <div class="flex flex-col items-stretch gap-y-3">
                        <p-radioButton label="Any User" name="allowAnyUser" [value]="true" [formControl]="allowAnyUserControl"></p-radioButton>
                        <p-radioButton label="Specific Users" name="allowAnyUser" [value]="false" [formControl]="allowAnyUserControl"></p-radioButton>
                      </div>
                      <div *ngIf="allowAnyUserControl.value == false && getControl('users') as userControl"
                           class="mt-3 shaded-well">
                        <ng-container *ngIf="getControl('userGroups') as groupControl">
                          <div class="p-grid p-nogutter p-jc-center">
                            <ng-container
                              *ngTemplateOutlet="toggleTemplate; context: createTemplateContext('requireAllSignoffs', { label: 'Require All' })"></ng-container>
                          </div>
                          <p-tabView>
                            <p-tabPanel>
                              <ng-template pTemplate="header">
                                <div class="p-d-flex p-jc-center p-ai-center w-100">
                                  <span class="p-mr-3">Users</span>
                                  <p-tag *ngIf="userControl.value" [value]="$any(userControl.value.length)"></p-tag>
                                </div>
                              </ng-template>
                              <ng-template pTemplate="content">
                                <ng-container
                                  *ngTemplateOutlet="logUserSignoffTemplate; context: createTemplateContext(userControl)"></ng-container>
                              </ng-template>
                            </p-tabPanel>
                            <p-tabPanel>
                              <ng-template pTemplate="header">
                                <div class="p-d-flex p-jc-center p-ai-center w-100">
                                  <span class="p-mr-3">Groups</span>
                                  <p-tag *ngIf="groupControl.value" [value]="$any(groupControl.value.length)"></p-tag>
                                </div>
                              </ng-template>
                              <ng-template pTemplate="content">
                                <ng-container
                                  *ngTemplateOutlet="userGroupSignoffTemplate; context: createTemplateContext(groupControl)"></ng-container>
                              </ng-template>
                            </p-tabPanel>
                          </p-tabView>
                        </ng-container>
                      </div>
                  </ng-container>
                </div>
                <div *ngIf="getControl('editUsers') as control" class="p-col-12">
                  <label>
                    <span>Edit Users</span>
                  </label>
                  <ng-container *ngTemplateOutlet="logUserSignoffTemplate; context: createTemplateContext(control)"></ng-container>
                </div>
            </ng-container>

        </ng-container>
    </div>
</div>

<ng-template #toggleTemplate let-key let-label="label">
    <div *ngIf="getControl(key) as control" class="p-col-3">
        <label [ngClass]="{'p-text-capitalize': !label}" class="p-d-flex p-flex-column p-jc-center text-center">
            <span>{{label ?? key}}</span>
            <p-inputSwitch [formControl]="$any(control)"></p-inputSwitch>
        </label>
    </div>
</ng-template>

<ng-template #logUserSignoffTemplate let-control>
    <ng-container *ngIf="segment">
        <lb-user-list-selector [logId]="logId" type="logUser" [formControl]="control"></lb-user-list-selector>
    </ng-container>
</ng-template>

<ng-template #userGroupSignoffTemplate>
    <ng-container *ngIf="segment && getControl('userGroups') as control">
        <lb-user-group-list-selector [logId]="logId" [formControl]="control"></lb-user-group-list-selector>
    </ng-container>
</ng-template>

<ng-template #signatureUserTableTemplate>
    <ng-container *ngIf="getControl('textList') as arrayControl">
        <p-table [value]="$any(arrayControl)">
            <ng-template pTemplate="header">
                <tr>
                    <th>Name</th>
                    <th class="p-col-1">Required</th>
                    <th class="p-col-1"></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-control let-index="rowIndex">
                <tr>
                    <td>
                        <input pInputText [formControl]="control.get(['text'])" placeholder="Required">
                    </td>
                    <td>
                        <div class="text-center">
                            <p-inputSwitch [formControl]="control.get(['required'])"></p-inputSwitch>
                        </div>
                    </td>
                    <td>
                        <div class="text-right">
                            <button pButton class="p-button-danger" [icon]="Icons.TRASH" (click)="removeTextListControl(index)"></button>
                        </div>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="footer">
                <tr>
                    <td colspan="3">
                        <div class="p-d-flex p-jc-end">
                            <button pButton [icon]="Icons.PLUS" (click)="addTextListControl()"></button>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </ng-container>
</ng-template>

<p-confirmDialog appendTo="body" [key]="warningDialogKey"></p-confirmDialog>